module.exports = __webpack_public_path__ + "img/logo.090be617.jpg";